<template>
  <div class="password-toggle">
    <input
      class="form-input"
      maxlength="8192"
      :id="inputId"
      :class="inputClass"
      :placeholder="placeholder"
      :type="inputType"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.enter="$emit('enter')" />
    <button
      class="password-toggle-icon"
      :aria-label="isPasswordVisible ? 'Hide password' : 'Show password'"
      v-if="faIcons.faEye && faIcons.faEyeSlash"
      @click.stop="toggleVisibility">
      <font-awesome-icon
        :icon="isPasswordVisible ? faIcons.faEyeSlash : faIcons.faEye" />
    </button>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'password-input-with-toggle',

  setup(props) {
    const isPasswordVisible = ref(false);
    const inputId = ref(props.id);
    const inputType = ref('password');

    const toggleVisibility = () => {
      isPasswordVisible.value = !isPasswordVisible.value;
      inputType.value = isPasswordVisible.value ? 'text' : 'password';
    };

    return {
      isPasswordVisible,
      inputId,
      inputType,
      toggleVisibility,
    };
  },

  emits: ['update:modelValue', 'enter'],

  props: {
    inputClass: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'password-input',
    },
    modelValue: String,
    placeholder: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.password-toggle {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.password-toggle .input-with-icon-offset {
  padding-left: 30px;
}

.password-toggle-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: none;
  font-size: 1.2rem;
  color: #555;
}

.password-toggle-icon:hover {
  opacity: 0.8;
}

.dark-mode .password-toggle-icon {
  color: #9d9d9d;
}
</style>
